<template>
  <el-dialog
      :visible="reds"
      @close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <div class="modal-box">
      <div class="modal-head">
        最终决策
      </div>
      <div :class="color(msg.lastResult||msg.result)">
        <div class="finally-head">
          {{ headText }}<span>{{ resultText }}</span>
        </div>
        <div class="finally-box">
          <div class="finally-h">{{ fromText }}</div>
          <div class="finally-p" v-for="item in hints">{{ item }}</div>
        </div>
      </div>
      <div class="redecision-bt-box">
        <div class="redecision-bt active" @click="handleOk">确定并退出本次决策</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    reds: {
      default: false,
      textarea: ''
    },
    msg: {}
  },
  data() {
    console.log(['finally.vue msg', this.msg])
    let headText = '基于系统建议决策：' // 基于公司决策：
    let resultText = ''
    let fromText = '基于以下原因作出判断:' // 具体解决方案:
    let hints = []
    if ('R4' === this.msg.lastResult) {
      headText = '基于公司决策：'
      fromText = '具体解决方案:'
      resultText = this.msg.socResultComment
      hints.push(this.msg.socResultCustomComment)
    } else {
      headText = this.msg.socResultComment ? '基于公司决策：' : '基于系统建议决策：'
      fromText = this.msg.socResultComment ? '基于公司决策作出判断：' : '基于以下原因作出判断:'
      resultText = this.msg.lastResultComment || this.msg.resultComment
      hints = this.msg.systemHints
    }
    return {
      headText,
      resultText,
      fromText,
      hints
    };
  },
  methods: {
    color(result) {
      // R1("起飞"),
      // R2("确认滑回"),
      // R3("等待"),
      // R4("公司决策"),
      console.log(['finally.vue color', result])
      switch (result) {
        case 'R1':
          return 'redecision-box green'
        case 'R2':
          return 'redecision-box red'
        case 'R3':
          return 'redecision-box yellow'
        case 'R4':
          return 'redecision-box blue'
      }
      return 'redecision-box'
    },
    handleClose() {
      this.$emit('handle-close')
    },
    handleOk() {
      this.$emit('ok')
    }
  }
}
</script>

<style lang="less" scoped>
.finally-head {
  font-size: 18px;

  span {
    color: #8EBF86;
  }
}

.finally-box {
  background: #393F52;
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;

  .finally-h {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
  }

  .finally-p {
    color: #fff;
    font-size: 16px;
    margin-top: 12px;
    display: flex;
    align-items: center;
  }
  .finally-p::before{
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    background: #8EBF86;
    border-radius: 50%;
    margin-right: 8px;
    margin-top: 2px;
  }
}

.modal-head {
  font-size: 18px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.redecision-box.active {
  .finally-head {
    span {
      color: #E07073;
    }
  }

  .finally-box {
    /*.finally-h {*/
    /*  color: #E07073;*/
    /*}*/
    .finally-p::before{
      background: #E07073;
    }
  }
}

.redecision-box.zdy {
  .finally-head {
    span {
      color: #2769EC;
    }
  }

  .finally-box {
    /*.finally-h {*/
    /*  color: #2769EC;*/
    /*}*/
    .finally-p::before{
      background: #2769EC;
    }
  }
}

.redecision-box.blue {
  .finally-head {
    span {
      color: #3F7CF6;
    }
  }

  .finally-box {
    /*.finally-h {*/
    /*  color: rgba(255, 255, 255, 0.6);*/
    /*}*/
    .finally-p::before{
      background: #3F7CF6;
    }
  }
}

.redecision-box.red {
  .finally-head {
    span {
      color: #E07073;
    }
  }

  .finally-box {
    /*.finally-h {*/
    /*  color: #E07073;*/
    /*}*/
    .finally-p::before{
      background: #E07073;
    }
  }
}

.redecision-box.green {
  .finally-head {
    span {
      color: #5CBE85;
    }
  }

  .finally-box {
    /*.finally-h {*/
    /*  color: #5CBE85;*/
    /*}*/
    .finally-p::before{
      background: #5CBE85;
    }
  }
}

.redecision-box.yellow {
  .finally-head {
    span {
      color: #EBA967;
    }
  }

  .finally-box {
    /*.finally-h {*/
    /*  color: #EBA967;*/
    /*}*/
    .finally-p::before{
      background: #EBA967;
    }
  }
}

.redecision-box {
  padding: 24px;
  text-align: left;
}

.redecision-bt-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;

  .redecision-bt {
    height: 44px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    width: 268px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .redecision-bt.active {
    height: 44px;
    border: 1px solid #2769EC;
    background: #2769EC;
    border-radius: 8px;
    width: 268px;
    margin-right: 0;
    flex: 1;
  }
}

/deep/ .el-dialog {
  background: #262D40;
  padding-bottom: 24px;
  width: 600px;
  border-radius: 12px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 23px;
  }

  .el-textarea {
    width: 390px;
  }

  .el-textarea textarea {
    height: 168px;
    background: #393F52;
    border-radius: 8px;
    margin: 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/finally.vue